/**
 * Type constraint that only accepts positive integers >= 1
 */
type PositiveInteger<T extends number> = `${T}` extends `-${string}`
  ? never // negative numbers
  : T extends 0
    ? never // zero
    : T; // positive integers

/**
 * Truncates a string to a maximum number of characters
 *
 * @param text - The string to truncate
 * @param maxChars - Must be a positive integer >= 1
 * @returns The truncated string if it exceeds maxChars, otherwise the original string
 * @throws {Error} Runtime error if maxChars < 1 (additional safety check)
 */
export const truncateString = <T extends number>(
  text: string,
  maxChars: PositiveInteger<T>,
): string => {
  if (maxChars < 1) {
    throw new Error('maxChars must be >= 1');
  }

  if (text.length <= maxChars) {
    return text;
  }

  return text.slice(0, maxChars);
};
